import { defineMessages } from 'react-intl';

export default defineMessages({
  allFunds: {
    id: 'features.offeringDocuments.allFunds',
    defaultMessage: 'CASE TERZE',
    description: 'accordion title to represents all funds group',
  },

  azimut: {
    id: 'features.offeringDocuments.azimut',
    defaultMessage: 'AZIMUT',
    description: 'accordion title to represents azimut group',
  },
  documentsNumber: {
    id: 'features.offeringDocuments.documentsNumber',
    defaultMessage: 'Numero documenti ({value})',
    description: 'label for number of documents',
  },

  // CompanyType

  allFundsCompanyType: {
    id: 'features.documentaArea.allFundsCompanyType',
    defaultMessage: 'ALLFUNDSBANK',
    description: 'value of funds company',
  },

  azimutCompanyType: {
    id: 'features.documentaArea.azimutCompanyType',
    defaultMessage: 'Azimut',
    description: 'value of azimut company',
  },

  // DocumentType

  kiidDocumentType: {
    id: 'features.documentaArea.kiidDocumentType',
    defaultMessage: 'KIID',
    description: 'value of kiid document type',
  },

  letterDocumentType: {
    id: 'features.documentaArea.letterDocumentType',
    defaultMessage: 'Lettera',
    description: 'value of letter document type',
  },
});
